import { TAction } from '../../types/customActions';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EChatCustomActionModalActionTypes {
  Show = 'chatCustomActionModal/show',
  Hide = 'chatCustomActionModal/hide',
}

export type TChatCustomActionModalShowPayload = {
  text: string;
  cancelButtonText: string;
  confirmButtonText: string;
  action: TAction;
  chatId: string;
};

export type TChatCustomActionModalAction =
  | ITypedReduxAction<EChatCustomActionModalActionTypes.Show, TChatCustomActionModalShowPayload>
  | ITypedReduxAction<EChatCustomActionModalActionTypes.Hide, void>;
